import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@app/shared/shared.module';
import { AnalysisRoutingModule } from './analysis-routing.module';
import { AnalysisMissingInvoiceNumberComponent } from './missing-invoice-number/analysis-missing-invoice-number.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { AnalysisMissingInvoiceNumberDetailComponent } from './missing-invoice-number/detail/analysis-missing-invoice-number-detail.component';
import { AnalysisMissingInvoiceNumberPdfViewerComponent } from './missing-invoice-number/pdf-viewer/analysis-missing-invoice-number-pdf-viewer.component';
import { ExportInvoicesActivityComponent } from './export-invoices-activity/export-invoices-activity.component';


@NgModule({
    declarations: [
        AnalysisMissingInvoiceNumberComponent,
        AnalysisMissingInvoiceNumberDetailComponent,
        AnalysisMissingInvoiceNumberPdfViewerComponent,
        ExportInvoicesActivityComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        AnalysisRoutingModule,
        NgMultiSelectDropDownModule.forRoot(),
        MatCheckboxModule,
        MatFormFieldModule,
        MatInputModule,
        MatSlideToggleModule,
        MatExpansionModule,
        MatChipsModule,
        MatRadioModule
    ],
    exports: [
        AnalysisMissingInvoiceNumberComponent,
        AnalysisMissingInvoiceNumberDetailComponent,
        AnalysisMissingInvoiceNumberPdfViewerComponent,
        ExportInvoicesActivityComponent
    ]
})
export class AnalysisModule { }
